import { useEffect, useState } from "react";

const SAMPLE_TYPES_TO_REQUIRE_PHLEBOTOMY = ["Blood", "Venous"];
const ORDER_DATE_THRESHOLD = 30 * 60 * 1000;

export default function useOrderConfirmation(order, isModal) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [requiresPhlebotomy, setRequiresPhlebotomy] = useState(false);

  useEffect(() => {
    if (isModal) {
      // Never show confirmation in modal
      setShowConfirmation(false);
      setRequiresPhlebotomy(false);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const isConfirmation = urlParams.has("confirmation");
    setShowConfirmation(isConfirmation);

    // let's check the order date, if it's in the last 30 minutes, we should
    // show the confirmation regardless of the query param
    if (
      order &&
      order.checkoutDate &&
      new Date(order.checkoutDate) > new Date(Date.now() - ORDER_DATE_THRESHOLD)
    ) {
      setShowConfirmation(true);
    }

    if (order) {
      const sampleTypes = order.testItems
        .map(item => item.product.sampleTypes)
        .filter(Boolean)
        .flat();
      const venousTypes = sampleTypes.filter(type =>
        SAMPLE_TYPES_TO_REQUIRE_PHLEBOTOMY.some(sampleType => type.includes(sampleType))
      );
      setRequiresPhlebotomy(venousTypes.length > 0);
    }
  }, [order, isModal]);

  return { showConfirmation, requiresPhlebotomy };
}
